// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".stickerReadonly__meta[data-v-0ffd752f]{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;gap:8px 40px;margin-bottom:8px}.stickerReadonly__packTags[data-v-0ffd752f]{margin:0 0 8px;text-align:center;color:#57534e;font-size:13px;line-height:1.4}.stickerReadonly__note[data-v-0ffd752f]{margin:8px 0 0;color:#57534e}.stickerReadonly__note--bad[data-v-0ffd752f]{color:#b91c1c}", ""]);
// Exports
module.exports = exports;
